import { Box, Grid, OutlinedInput, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";

import Alert from "components/shared/Alert";
import RightContent from "components/wrappers/RightContent";
import useApp, { ProductLevel } from "hooks/useApp";
import { QuoteContext, QuoteProvider } from "hooks/useQuote";
import { colors } from "theme";

import { DataTable } from "./components/DataTable";

const useStyles = makeStyles({
  extSearchField: {
    "& > .MuiInputBase-input::placeholder": {
      color: colors.grey[100],
      fontSize: 12,
      opacity: 1,
    },
  },
});

export const Quotes = () => {
  const { productLevel } = useApp();
  const classes = useStyles();

  return (
    <QuoteProvider>
      <QuoteContext.Consumer>
        {({ panelTransferred }) => (
          <RightContent>
            <Grid container justifyContent="space-between">
              <Typography variant="h1">Quote History</Typography>
              {productLevel !== ProductLevel.MVP && (
                <Grid item md={4}>
                  <OutlinedInput
                    fullWidth
                    placeholder="Search Requisition #"
                    aria-label="Search for requisition numbers in the quotes table"
                    endAdornment={<SearchIcon />}
                    className={classes.extSearchField}
                  />
                </Grid>
              )}
            </Grid>
            {panelTransferred && (
              <Box mt={3}>
                <Alert severity="info" noDismiss icon={false}>
                  Panel ownership has been transferred successfully
                </Alert>
              </Box>
            )}
            <Box mt={10}>
              <DataTable />
            </Box>
          </RightContent>
        )}
      </QuoteContext.Consumer>
    </QuoteProvider>
  );
};
